module.exports = __webpack_public_path__ + "img/menu.4d49f5d7.svg";